import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../store/userSlice";
import { useForm } from "react-hook-form";
import Signin from "../../components/User/Signin";
import Signup from "../../components/User/Signup";
import ForgetPassword from "../../components/User/ForgetPassword";
import Verify from "../../components/User/Verify";
import style from "./index.module.css";
import { PagesType, socialLogin, submitFormData } from "./utils";
import ChangeForgottenPassword from "../../components/User/ChangeForgottenPassword";
import { useScrollToTop } from "../../utils/generalUtils";
import { useTranslation } from "../../hooks/useTranslation";

const Sign = ({ history }: any) => {
  const { locale } = useTranslation();
  const { user } = useSelector(selectUser);

  useScrollToTop();

  // TODO: Refactor sign in/up into separate pages to improve UX and enable direct link sharing for each authentication flow
  const [activePage, setActivePage] = useState<PagesType>("signin");

  const [submittingState, setSubmittingState] = useState<{
    isSubmitting: boolean;
    submitSuccess: boolean;
    error: string;
  }>({
    isSubmitting: false,
    submitSuccess: false,
    error: "",
  });

  const [isSocialRegister, setIsSocialRegister] = useState<boolean>(false);

  const dispatch = useDispatch();

  // TODO: we should add valdidation for all fields
  const {
    register,
    watch,
    setValue,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      signin_phone: "",
      signin_password: "",
      signin_remember: false,
      signup_name: "",
      // signup_email: "",
      signup_phone: "",
      signup_password: "",
      signup_confirm_password: "",
      forget_phone: "",
      forget_password: "",
      forget_confirm_password: "",
      verify_code: "",
    },
  });

  useEffect(() => {
    if (user) {
      history.replace("/");
    }
  }, [user, history]);

  const onSubmitFormHandler = useCallback(
    // TODO: use the correct type for the data object
    async (data: any) => {
      await submitFormData(data, activePage, setActivePage, setSubmittingState, dispatch, locale, history);
    },
    [locale, activePage, dispatch, history],
  );

  // const onSocialLoginHandler = useCallback(
  //   async (provider: "facebook" | "google", data: any) => {
  //     if (data.accessToken) {
  //       setSubmittingState({
  //         isSubmitting: true,
  //         error: "",
  //         submitSuccess: false,
  //       });
  //       let error = "";
  //       await socialLogin(provider, data.accessToken)
  //         .then((res) => {
  //           if (!res.data.data.phone) {
  //             setValue("signup_name", res.data.data.name);
  //             // setValue("signup_email", res.data.data.email);
  //             const password = Math.ceil(Math.random() * 100000000).toString();
  //             setValue("signup_password", password);
  //             setValue("signup_confirm_password", password);
  //             setIsSocialRegister(true);
  //             setActivePage("signup");
  //           }
  //         })
  //         .catch((err) => {
  //           error = "Error occured!";
  //         });
  //       setSubmittingState({
  //         isSubmitting: true,
  //         error,
  //         submitSuccess: false,
  //       });
  //     }
  //   },
  //   [setValue]
  // );

  const onChangePageHandler = useCallback(
    (target: PagesType) => {
      reset();
      setSubmittingState({
        error: "",
        isSubmitting: false,
        submitSuccess: false,
      });
      setActivePage(target);
    },
    [reset],
  );

  return (
    <div className="main_section">
      <div className="container-lg">
        <div className="section_content_padding">
          <div className={style.section_header}>
            {(activePage === "signin" || activePage === "signup") && (
              <>
                <button
                  className={activePage === "signin" ? style.active : ""}
                  onClick={() => (activePage === "signin" ? {} : onChangePageHandler("signin"))}
                >
                  <h3 className="main_section__title main_section__title--small">{locale("signin")}</h3>
                </button>
                <button
                  className={activePage === "signup" ? style.active : ""}
                  onClick={() => (activePage === "signup" ? {} : onChangePageHandler("signup"))}
                  disabled={submittingState.isSubmitting}
                >
                  <h3 className="main_section__title main_section__title--small">{locale("signup")}</h3>
                </button>
              </>
            )}
            {(activePage === "forget" || activePage.includes("verify") || activePage === "change_forget_password") && (
              <>
                <h3 className="main_section__title main_section__title--small">
                  {locale(
                    activePage === "forget"
                      ? "forgot_password"
                      : activePage === "change_forget_password"
                      ? "change_password"
                      : "verification",
                  )}
                  .
                </h3>
                {(activePage === "forget" || activePage.includes("verify")) && (
                  <p>{locale(activePage === "forget" ? "enter_phone_email_account" : "we_sent_code")}</p>
                )}
                {activePage === "change_forget_password" && submittingState.submitSuccess && (
                  <p style={{ color: "#35b545" }}>{locale("change_password_successfuly")}</p>
                )}
              </>
            )}
            {submittingState.error && <p className={style.submission_error}>{submittingState.error}</p>}
            {activePage === "verify_signup" && submittingState.submitSuccess && (
              <p style={{ color: "#35b545" }}>{locale("registered_successfuly")}</p>
            )}
          </div>
          <form onSubmit={handleSubmit(onSubmitFormHandler)} className={style.main_form}>
            {(activePage === "signin" || activePage === "signup") && (
              <div className={style.sign_section}>
                {activePage === "signin" && (
                  <Signin
                    register={register}
                    errors={errors}
                    setActivePage={onChangePageHandler}
                    // onSocialLoginHandler={onSocialLoginHandler}
                    isSubmitting={submittingState.isSubmitting}
                  />
                )}
                {activePage === "signup" && (
                  <Signup
                    register={register}
                    watch={watch}
                    errors={errors}
                    isSubmitting={submittingState.isSubmitting}
                    isSocialRegister={isSocialRegister}
                  />
                )}
              </div>
            )}
            {(activePage === "forget" || activePage.includes("verify") || activePage === "change_forget_password") && (
              <div className={style.verify_section}>
                {activePage === "forget" && (
                  <ForgetPassword
                    register={register}
                    setActivePage={onChangePageHandler}
                    isSubmitting={submittingState.isSubmitting}
                  />
                )}
                {activePage.includes("verify") && (
                  <Verify register={register} setValue={setValue} isSubmitting={submittingState.isSubmitting} />
                )}
                {activePage.includes("change_forget_password") && (
                  <ChangeForgottenPassword
                    register={register}
                    isSubmitting={submittingState.isSubmitting}
                    setActivePage={setActivePage}
                    watch={watch}
                    errors={errors}
                    submitSuccess={submittingState.submitSuccess}
                  />
                )}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Sign;
